<template>
  <draggable-dialog
    v-model:visible="visible"
    top="6vh"
    draggable
    :modal="false"
    destroy-on-close
    :show-close="true"
    :close-on-click-modal="false"
    modalPenetrable
    append-to-body
  >
    <template #header>
      预览图片
    </template>
    <div class="imgPreviewer-wrap">
      <img
        v-for="(item,idx) in props.urlList"
        :src="item"
        ref="imgRefs"
        class="imgPreviewer-img"
        :key="idx"
        @click="handlePreview(item)"
      />
    </div>

    <el-image-viewer
      v-if="imgPreVis"
      hide-on-click-modal
      :url-list="[imgPreUrl]"
      @close="()=>{imgPreVis = false}"
    />

  </draggable-dialog>
</template>

<script setup>
import DraggableDialog from "@/components/OnlineWps/draggableDialog.vue";
const visible = defineModel("visible", { type: Boolean, default: false });

const props = defineProps({
  urlList: {
    type: Array,
    required: true,
    default: () => [],
  },
  initialIndex: {
    type: Number,
    required: true,
    default: 0,
  },
});

const imgRefs = ref([])

watch(
  visible,
  () => {
    if (visible.value) {
      nextTick(() => {

        let count = 0;

        imgRefs.value.forEach(img => {
          img.onload = () => {
            count++
            if (count == imgRefs.value.length) { // 图片全部加载完成
              const cur = imgRefs.value[props.initialIndex]
              setTimeout(() => {
                cur.scrollIntoView({
                  behavior: 'smooth', // 平滑滚动（可选，去掉则瞬间跳转）
                  block: 'start'      // 元素对齐父容器顶部（默认值，可省略）
                });
              }, 50)
            }
          }
        });
      })
    }
  }
);

const imgPreVis = ref(false)
const imgPreUrl = ref('')

function handlePreview(file) {
  imgPreUrl.value = file
  imgPreVis.value = true
}
</script>

<style lang="scss" scoped>
.imgPreviewer-wrap {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  overflow-y: auto;
  padding-right: 5px;

  :deep(.imgPreviewer-img) {
    width: 100%;
    height: auto;
    flex-shrink: 0;
    margin-top: 10px;
    display: block;
    cursor: pointer;
    &:first-child {
      margin-top: 0;
    }
  }
}
</style>
